export const tableHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: "Organización",
          type: "custom-html",
          key: "org",
          modifier: (item) => {
            if(item) {
              if(item.country && item.country_id == 1) {
                return "Unidad Técnica - " + item.canton.name;
              } else {
                return "Unidad Técnica - " + item.city;
              }
            } else {
              return 'Matriz';
            }
          },
        },
        // {
        //     title: 'Localización',
        //     type: 'text',
        //     key: 'location',
        // },
        /* {
          title: "Sector",
          type: "custom-html",
          key: "level_2",
          modifier: (item) => {
            return item.value;
          },
        }, */
        {
          title: "Categoría",
          type: "custom-html",
          key: "level_3",
          modifier: (item) => {
            return item.value;
          },
        },
        {
          title: "Campo",
          type: "custom-html",
          key: "level_4",
          modifier: (item) => {
            return item.value;
          },
        },
        {
          title: "Producto",
          type: "custom-html",
          key: "level_7_selected",
          modifier: (item) => {
            let tmp = "";
            item.forEach((element, index) => {
              tmp += `<p>${element.scope_master.description}</p>`;
            });
            return tmp;
          },
        },
        {
          title: "Técnica",
          type: "custom-html",
          key: "level_5",
          modifier: (item) => {
            return item.value;
          },
        },
        {
          title: "Ensayo",
          type: "custom-html",
          key: "level_6",
          modifier: (item) => {
            return item.value;
          },
        },
        {
          title: "Rango",
          key: "level8",
          type: "custom-html",
          modifier: (item) => {
            return item;
          },
        },
        {
          title: "Método Interno ",
          key: "level9",
          type: "custom-html",
          modifier: (item) => {
            return item;
          },
        },
        {
          title: "Método Referencia (revisión/edición) ",
          key: "level10",
          type: "custom-html",
          modifier: (item) => {
            return item;
          },
        },
      ],
      actionObj: {
        title: "Acción",
        type: "action",
      },
    };
  },
};
